import React, { useEffect } from "react";
import {  Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import { useDispatch } from "react-redux";
import Error404 from "feature-module/auth/error/error-404/error400";
// import HomeFour from "feature-module/HomePages/home-four/homeFour";

const ALLRoutes = () => {
  const dispatch=useDispatch()
 


  return (
    <>
      <Routes>
        {/* <Route path="/" element={<HomeFour />} /> */}
        <Route element={<Feature />}>
        
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route path="*" element={<Error404/>} />
      </Routes>
    </>
  );
};

export default ALLRoutes;
